"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOAD_PHONE_REGIONS_SUCCESS = exports.LOAD_PHONE_REGIONS_REQUEST = exports.LOAD_PHONE_REGIONS_FAIL = void 0;
var LOAD_PHONE_REGIONS_REQUEST = exports.LOAD_PHONE_REGIONS_REQUEST = '@Resource/LOAD_PHONE_REGIONS_REQUEST';
var LOAD_PHONE_REGIONS_SUCCESS = exports.LOAD_PHONE_REGIONS_SUCCESS = '@Resource/LOAD_PHONE_REGIONS_SUCCESS';
var LOAD_PHONE_REGIONS_FAIL = exports.LOAD_PHONE_REGIONS_FAIL = '@Resource/LOAD_PHONE_REGIONS_FAIL';